<template>
    <md-card>
        <md-card-header>
            <span v-if="type === 'Demand'">Demandas</span>
            <span v-else>Pedidos</span>
        </md-card-header>
        <md-card-content>
            <div class="md-layout text-center">
                <span
                    class="number"
                    v-if="type === 'Demand'"
                    :style="demandsColor"
                    >{{ totalTasks.total.demand }}</span
                >
                <span class="number" v-else :style="solicitationColor">{{
                    totalTasks.total.solicitation
                }}</span>
                <span v-if="type === 'Demand'">
                    Casos não analisados
                </span>
                <span v-else> Pedidos em aberto </span>
            </div>
        </md-card-content>
        <md-card-content>
            <div class="container-items">
                <span>
                    <strong class="today-number">
                        {{
                            type === 'Demand'
                                ? totalTasks.today.demand
                                : totalTasks.today.solicitation
                        }}
                    </strong>
                    de hoje,
                    <span class="yesterday-number">{{
                        type === 'Demand'
                            ? totalTasks.yesterday.demand
                            : totalTasks.yesterday.solicitation
                    }}</span>
                    de ontem,
                    <span class="evenBefore">
                        {{
                            type === 'Demand'
                                ? totalTasks['two-or-more-days-before'][
                                      'demand'
                                  ]
                                : totalTasks['two-or-more-days-before'][
                                      'solicitation'
                                  ]
                        }}
                    </span>
                    do dia
                    {{ formattedDate() }}
                    ou anterior
                </span>

                <md-button
                    class="md-just-icon md-simple"
                    @click="handleFilters"
                >
                    <md-icon>file_upload</md-icon>
                </md-button>
            </div>
        </md-card-content>
    </md-card>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            require: true
        },
        value: {
            type: [Number, Array]
        },
        totalTasks: {
            type: Object
        },
        actions: {
            type: Function,
            default(i) {
                return i
            }
        }
    },
    methods: {
        handleFilters() {
            const startDate = new Date().setDate(new Date().getDate() - 2)
            const endDate = new Date()

            if (this.type !== 'Demand') {
                this.$router.push({
                    name: 'Pedidos',
                    params: { startDate, endDate, status: 'P' }
                })
            } else {
                this.$router.push({
                    name: 'Gestão de Demanda',
                    params: { startDate, endDate, status: 'O' }
                })
            }
        },
        formattedDate() {
            let date = new Date()
            date.setDate(date.getDate() - 2)

            return (
                ('0' + date.getDate()).slice(-2) +
                '/' +
                ('0' + (date.getMonth() + 1)).slice(-2)
            )
        }
    },
    computed: {
        demandsColor() {
            return {
                color:
                    this.totalTasks['two-or-more-days-before']['demand'] > 0
                        ? 'red'
                        : this.totalTasks.yesterday.demand > 0
                        ? rgb(58, 96, 201)
                        : this.totalTasks.today.demand > 0
                        ? 'green'
                        : 'initial'
            }
        },
        solicitationColor() {
            return {
                color:
                    this.totalTasks['two-or-more-days-before']['solicitation'] >
                    0
                        ? 'red'
                        : this.totalTasks.yesterday.solicitation > 0
                        ? rgb(58, 96, 201)
                        : this.totalTasks.today.solicitation > 0
                        ? 'green'
                        : 'initial'
            }
        }
    }
}
</script>
<style scoped>
.container-items {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.number {
    font-size: 34px;
    margin-right: 10px;
}

.evenBefore {
    color: red;
}

.yesterday-number {
    color: rgb(58, 96, 201);
}

.today-number {
    color: green;
}
</style>
